(function() { window.GUID_43effa68_0153_4df2_b57e_ccb6bc890788 = { getGuid: function() { return "43effa68-0153-4df2-b57e-ccb6bc890788"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let NewsfeedFilter;
        (function (NewsfeedFilter) {
            NewsfeedFilter[NewsfeedFilter["All"] = 0] = "All";
            NewsfeedFilter[NewsfeedFilter["FromMe"] = 1] = "FromMe";
            NewsfeedFilter[NewsfeedFilter["ToMe"] = 2] = "ToMe";
        })(NewsfeedFilter = Enumeration.NewsfeedFilter || (Enumeration.NewsfeedFilter = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=NewsfeedFilter.pre.js.map
